import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class BeneficiaryIndraService {

  private beneficiaryNames$ = new BehaviorSubject<any>({});
  currentBeneficiaryNames$ = this.beneficiaryNames$.asObservable();

  private beneficiaryList$ = new BehaviorSubject<any>({});
  currentBeneficiaryList$ = this.beneficiaryList$.asObservable();

  private numberOfBeneficiaries$ = new BehaviorSubject<any>({});
  currentNumberOfBeneficiaries$ = this.numberOfBeneficiaries$.asObservable();

  private passengers$ = new BehaviorSubject<any>({});
  currentPassengers$ = this.passengers$.asObservable();

  private paxSalutations$ = new BehaviorSubject<any>({});
  currentPaxSalutations$ = this.paxSalutations$.asObservable();

  constructor() { }

  setBeneficiaryNames(beneficiaryNames: any[]) {
    this.beneficiaryNames$.next(beneficiaryNames)
  }

  setBeneficiaryList(beneficiaryList: any[]) {
    this.beneficiaryList$.next(beneficiaryList)
  }

  setNumberOfBeneficiaries(number: number) {
	  this.numberOfBeneficiaries$.next(number);
  }

  setPassengers(passengers: any[]) {
    this.passengers$.next(passengers)
  }

  setPaxSalutations(paxSalutations: any[]) {
    this.paxSalutations$.next(paxSalutations);
  }

  INDRA_formatCapitalization(salutation: string): string {
		return salutation.charAt(0).toUpperCase() + salutation.slice(1).toLowerCase();
	}

  INDRA_formatPaxSalutations(rawPaxSalutations: String[]): object[] {
		let salutationsArray = []
		rawPaxSalutations.forEach(salutation => {
			let splitted = salutation.toUpperCase().split(";");
			salutationsArray.push({
				salutation: splitted[0],
				typePax: splitted[1],
				gender: splitted[2],
			})
		});
		return salutationsArray;
	}

  INDRA_getTypePaxFromSalutation(paxSalutations: any[], salutation: string): any {
		let returnable: string = "";
    paxSalutations.forEach(sal => {
			if (sal.salutation.toUpperCase() == salutation.toUpperCase()) {
				returnable = sal.typePax;
			}
		});
    return returnable;
	}

  INDRA_getSalutationFromTypePax(paxSalutations: any[], typePax: string): any {
    let returnable: string = "";
		paxSalutations.forEach(sal => {
			if (sal.typePax.toUpperCase() == typePax.toUpperCase()) {
				returnable = sal.salutation;
			}
		});
    return returnable;
	}

  INDRA_getSalutationFromGender(paxSalutations: any[], gender: string): any {
    let returnable: string = "";
		paxSalutations.forEach(sal => {
			if (sal.gender.toUpperCase() == gender.toUpperCase()) {
				returnable = sal.salutation;
			}
		});
    return returnable;
	}
  
  INDRA_getGenderFromSalutation(paxSalutations: any[], salutation: string): any {
    let returnable: string = "";
		paxSalutations.forEach(sal => {
			if (sal.salutation.toUpperCase() == salutation.toUpperCase()) {
				returnable = sal.gender;
			}
		});
    return returnable;
	}
}